import { useCallback } from 'react';

import { useShareRecommendationsExperiment } from '../../../../../../hooks/useShareRecommendationsExperiment';

import { useTipSharingModal } from './useTipSharingModal';

export function useTriggerTipSharingModal(): () => Promise<void> {
	const openTipSharingModal = useTipSharingModal();
	const {
		data: { variant: recommendationsExperimentVariant },
	} = useShareRecommendationsExperiment();

	return useCallback(async () => {
		return openTipSharingModal({ variant: recommendationsExperimentVariant }).waitForResult();
	}, [openTipSharingModal, recommendationsExperimentVariant]);
}
